export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems[0]))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.title    = json.title
      this.status   = json.status
      this.columns  = json.columns
      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries = json.sundries
      

      this.gmx_tableCoordinates('x', this.columns, 0)
      this.status.width = this.columns[this.columns.length-1].ex

    },

  }
}